import { api } from "@/api/client";

export interface SessionResponse {
  access_token: string;
  access_token_expires_at: string;
  refresh_token: string;
  refresh_token_expires_at: string;
  user: { id: string; email: string; created_at: string; role?: "user" | "admin" };
}

export const authApi = {
  magicLink: (email: string) =>
    api.post<{ ok: true }>("/auth/magic-link", { email }, { skipAuth: true }),

  // dashboard-api accepts the magic-link token via GET ?token=…
  callback: (token: string) =>
    api.get<SessionResponse>("/auth/callback", { skipAuth: true, query: { token } }),

  refresh: (refresh_token: string) =>
    api.post<SessionResponse>("/auth/refresh", { refresh_token }, { skipAuth: true }),

  logout: () => api.post<{ ok: true }>("/auth/logout"),

  logoutAll: () => api.post<{ ok: true }>("/auth/logout-all"),
};
